export const APP_TITLE = 'CMS';
